import { View } from "react-native";
import IconMinus from "src/icons/IconMinus";
import IconPlus from "src/icons/IconPlus";
import useGatheringHomeNumColumnsRange from "src/screens/(internal)/(GatheringHome)/_/hooks/useGatheringHomeNumColumnsRange";
import { radiusMedium } from "src/styles/radius";
import { paddingMedium } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import useGatheringFilterSortStore from "../../hooks/useGatheringFilterSortStore";
import GatheringFilterSortCard from "../GatheringFilterSortCard";
import ActionIconButton from "./components/ActionIconButton";

const GatheringFilterSortNumColumns = () => {
	const numColumnsTarget = useGatheringFilterSortStore((state) => state.numColumnsTarget);
	const setNumColumnsTarget = useGatheringFilterSortStore((state) => state.setNumColumnsTarget);
	const { minNumColumns, maxNumColumns, defaultNumColumns } = useGatheringHomeNumColumnsRange();
	const numColumns = Math.max(
		Math.min(numColumnsTarget ?? defaultNumColumns, maxNumColumns),
		minNumColumns,
	);

	return (
		<View
			style={{
				borderRadius: radiusMedium,
				overflow: "hidden",
			}}
		>
			<GatheringFilterSortCard
				text="Photos per row"
				renderSelector={() => {
					return (
						<View
							style={{
								flexDirection: "row",
								alignItems: "center",
								// Min width to try to avoid layout shift for reasonable size values
								minWidth: 80,
								justifyContent: "space-between",
								columnGap: paddingMedium,
							}}
						>
							<ActionIconButton
								Icon={IconMinus}
								disabled={numColumns <= minNumColumns}
								onPress={() => {
									setNumColumnsTarget(numColumns - 1);
								}}
							/>
							<Text semibold small>
								{numColumns}
							</Text>
							<ActionIconButton
								Icon={IconPlus}
								disabled={numColumns >= maxNumColumns}
								onPress={() => {
									setNumColumnsTarget(numColumns + 1);
								}}
							/>
						</View>
					);
				}}
			/>
		</View>
	);
};
export default GatheringFilterSortNumColumns;
